module.exports = __webpack_public_path__ + "img/dr_mrs_namihira.80e601ee.jpg";